module.exports = __webpack_public_path__ + "assets/b35.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b35.png
// module id = 622
// module chunks = 0